export enum UserParameterType {
  None = 0,
  Boolean = 1,
  Int = 2,
  Decimal = 3,
  SharedList = 4,
  Text = 5,
}
